/* eslint no-unused-vars: 0 */
import $ from 'jquery';

import initScrollTo from './scroll-to';
import mobileMenu from './mobile-menu';
import loadNumbers from './load-numbers';
import categoryFilter from './category-filter';
import readMore from './read-more';

// Pick what browserify tests you need
// require('browsernizr/test/css/flexbox');
// const Modernizr = require('browsernizr');

$(document).ready(() => {
    const $jsScrollTo = $('.js-scroll-to');
    if ($jsScrollTo.length) {
        $jsScrollTo.map((i, v) => initScrollTo(v));
    }

    const $jsMobileMenu = $('.js-toggle-menu');
    if ($jsMobileMenu.length) {
        $jsMobileMenu.map((i, v) => mobileMenu(v));
    }

    const $loadNumbers = $('.js-load-numbers');
    if ($loadNumbers.length) {
        $loadNumbers.map((i, v) => loadNumbers(v));
    }

    const $categoryFilter = $('.js-category-filter');
    if ($categoryFilter.length) {
        $categoryFilter.map((i, v) => categoryFilter(v));
    }

    const $readMore = $('.js-read-more');
    if ($readMore.length) {
        $readMore.map((i, v) => readMore(v));
    }
});
